export default __webpack_public_path__ + "static/small-business-accomplishment-1b-d5cd4e65369eb7f33e022d3d54e73760.webp";